import React from "react";
import { useCompanySettings, useTemplateSetting } from "../hooks/useCompanySettings";
import { i18n } from "@euroland/libs";
import { classNames } from "../utils";
import { TOOL_TEMPLATE } from "../constant/common";
import { useSelector } from "react-redux";
import { loadedInstrumentSelector } from "../store/slice/trade";

export default function Footer() {
  const {
    showSupplierInfo,
    showDataDelayInfo,
    showDisclaimerInfo,
    showSupplierInfoLink,
    showCookiePolicyInfo,
    showPrivacyPolicyInfo = true,
  } = useCompanySettings();
  const { language, termsOfServiceURL, cookiePolicyURL, suppliedByLanguage, eurolandURL, privacyPolicyURL } =
    window.appSettings;
  const euroland = eurolandURL || "https://www.euroland.com/";
  const termsOfService = termsOfServiceURL || "https://tools.eurolandir.com/legal/terms/";
  const cookiePolicy = cookiePolicyURL || "https://tools.eurolandir.com/legal/cookie/";
  const privacyPolicy = privacyPolicyURL || "https://tools.eurolandir.com/legal/privacy/";

  const template = useTemplateSetting();
  const loadedInstruments = useSelector(loadedInstrumentSelector);

  if (!loadedInstruments) return null;
  return (
    <footer
      className={classNames("footer", {
        "has-provider-info": showSupplierInfo,
        "has-dataDelay-info": showDataDelayInfo,
        "has-disclaimer-info": showDisclaimerInfo,
        "footer-victor": template === TOOL_TEMPLATE.victor,
        "footer-quadrata": template === TOOL_TEMPLATE.quadrata,
      })}
    >
      <div className="footer-content">
        {showSupplierInfo && (
          <p className="footer-content_primary">
            {i18n.translate("supplyBy")}
            {showSupplierInfoLink && (
              <a
                target="_blank"
                rel="noreferrer"
                className="footer__supplierInfoLink"
                href={`${euroland}?SelectLanguage=${suppliedByLanguage || "english"}`}
              >
                {i18n.translate("euroland_com")}
              </a>
              // <span className="footer__supplierInfoLink" />
            )}
          </p>
        )}

        <div className="footer-content_secondary">
          {/* {showDataDelayInfo && <p>{i18n.translate("dataDelay")}</p>} */}
          {(showDisclaimerInfo || showPrivacyPolicyInfo || showCookiePolicyInfo) && (
            <p>
              {showDisclaimerInfo && (
                <a href={`${termsOfService}?lang=${language}`} target="_blank" rel="noreferrer">
                  {i18n.translate("termsOfService")}
                </a>
              )}
              
              {showDisclaimerInfo && showPrivacyPolicyInfo && <span> | </span>}

              {showPrivacyPolicyInfo && (
                <a href={`${privacyPolicy}?lang=${language}`} target="_blank" rel="noreferrer">
                  {i18n.translate("privacyPolicy")}
                </a>
              )}
              {showDisclaimerInfo && !showPrivacyPolicyInfo && showCookiePolicyInfo && <span> | </span>}

              {showPrivacyPolicyInfo && showCookiePolicyInfo && <span> | </span>}

              {showCookiePolicyInfo && (
                <a href={`${cookiePolicy}?lang=${language}`} target="_blank" rel="noreferrer">
                  {i18n.translate("cookiePolicy")}
                </a>
              )}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
